import { Observable } from 'rxjs';
import { TpvBulkMerchantsResult } from '@app/domain/models/tpv/merchant-bulk.model';
import { TpvReportFile } from '@app/domain/models/tpv/tpv-report.model';

/**
 * Port del alta masiva de comercios del TPV (escritura, IsAdmin).
 *
 * - Alta masiva: el cuerpo es un ARRAY JSON (NO multipart); el front parsea el
 *   archivo y manda la lista ya parseada (contrato §4).
 * - Plantilla: archivo Base64 (mismo patrón que los reportes, contrato §5).
 */
export abstract class MerchantBulkRepository {
  abstract createBulk(
    merchants: unknown[],
    idempotencyKey?: string,
  ): Observable<TpvBulkMerchantsResult>;

  abstract getTemplate(): Observable<TpvReportFile>;
}
